import { splitToken } from 'dibs-cookie-jar/exports/splitToken';
import { datadogRum } from '@datadog/browser-rum';

let guestUserToken: string | undefined;

export function getGuestUserToken(): string | undefined {
    return guestUserToken;
}

export function getGuestUserId(): string | null {
    if (guestUserToken) {
        return splitToken(guestUserToken);
    }
    return null;
}

export function setGuestUserToken(token: string | null): void {
    let userId;
    if (token) {
        guestUserToken = token;
        userId = splitToken(token);
    } else {
        guestUserToken = undefined;
    }
    if (userId) {
        datadogRum.setGlobalContextProperty('checkoutGuestUser', true);
        datadogRum.setUser({
            id: userId,
        });
    } else {
        datadogRum.removeGlobalContextProperty('checkoutGuestUser');
        datadogRum.clearUser();
    }
}
